import apivendas from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    refresh: 'N',
  },

  getters: {
    list: (state) => state.list,
    refresh: (state) => state.refresh,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apivendas.get('venda', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async equals(_, queries) {
      // FILTER -> Retorna valores não nulos.
      // SORT -> Ordena alfabeticamente pelas propriedades.
      // REDUCE -> Reconstrói o objeto.

      const formataAntiga = Object.keys(queries.queryAntiga)
        .filter((key) => !!queries.queryAntiga[key] && queries.queryAntiga[key] !== 'null')
        .sort()
        .reduce((obj, key) => ({ ...obj, [key]: queries.queryAntiga[key] }), {});

      const formataQuery = Object.keys(queries.query)
        .filter((key) => !!queries.query[key] && queries.query[key] !== 'null')
        .sort()
        .reduce((obj, key) => ({ ...obj, [key]: queries.query[key] }), {});

      console.log(JSON.stringify(formataAntiga));
      console.log(JSON.stringify(formataQuery));
      return JSON.stringify(formataAntiga) === JSON.stringify(formataQuery);
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    refresh(state, refresh) {
      state.refresh = refresh ?? '';
    },
  },
};
